export interface EventNotification {
    DeviceId: number;
    StateEventDescr: string;
    NotifyLevel: number;
    Data: string;
    Message: string;
}

export interface EventMessage extends EventNotification {
    Description: string;
    Category: string;
    UserId: number;
    Payload: string;
    EventDate: Date;
    CreatedAt: Date;
    Username: string;
}


export class EventMessageExport {
    EventDate: string;
    Username: string;
    Device: string;
    Type: string;
    Description: string;
    Message: string;
}

export interface EventType {
    Id: number;
    Description: string;
    Category: string;
}

export enum EEventCategory {
    DeviceEvent = 'DeviceEvent',
    TicketEvent = 'TicketEvent',
    SceneryEvent = 'SceneryEvent',
    UserEvent = 'UserEvent',
}

export enum EEventNotifylevel {
    None = 0,
    Info = 1,
    Warning = 2,
    Error = 3,
    Debug = 10,
    Auto = 255,
    Defualt = 0,
}

export enum EDeviceEvents {
    commandInvoked = 5,
    commandExecuted = 6,
    commandNotExecutedError = 7,
    registerUpdated = 9,
    registerUpdatedError = 10,
    gatewayConfigured = 12,
    gatewayConfigurationError = 13,
    subgatewayConfigured = 14,
    subgatewayConfigurationError = 15,
    deviceConfigured = 16,
    deviceConfigurationError = 17,
    nonGatewayConfigured = 18,
    nonGatewayConfigurationError = 19,
    nonGatewayRemoved = 20,
    varcoStatusUpdate = 21,
    varcoErrorUpdate = 22,
    manouverCountUpdate = 23,
    deviceInputUpdate = 24,
    deviceOutputUpdate = 25,
    deviceOnline = 26,
    inputUpdate = 27,
    outputUpdate = 28,
    gatewayRemoved = 29,
    subgatewayRemoved = 30,
    deviceRemoved = 31,
    outCmdInvoked = 33,
    outCmdExecuted = 34,
    outCmdNotExecuted = 35,
}



// {
//     "DeviceId": 3677,
//     "StateEventDescr": "CommandInvoked",
//     "NotifyLevel": 0,
//     "Data": "{\"CommandId\":2,\"DeviceEventId\":5,\"DeviceId\":3677,\"OperationId\":0,\"Payload\":[]}",
//     "Message": "E' stato invocato il comando Apertura sul dispositivo ZL65 TEST"
// }
